export const IS_LOCATION_PICKER_ACTIVE = "IS_LOCATION_PICKER_ACTIVE"